module.exports = __webpack_public_path__ + "img/sustainity_logo_branding.99f8242a.png";